import { forwardRef } from "react";

import * as RadixToggle from "@radix-ui/react-toggle";

import { cn } from "../index";

type ToggleProps = RadixToggle.ToggleProps;

const Toggle = forwardRef<HTMLButtonElement, ToggleProps>(({ className, ...props }, forwardedRef) => (
  <RadixToggle.Root
    {...props}
    ref={forwardedRef}
    className={cn(
      `box-border flex cursor-pointer items-center justify-center rounded-[5px] border border-primary-darker-gray bg-primary-white p-[5px] text-primary-dark-blue select-none data-[state=off]:text-primary-dark-blue data-[state=on]:text-primary-blue`,
      className,
    )}
  />
));

export { Toggle };
export type { ToggleProps };
